var map = {
  "./cs.json": [
    "VY",
    [
      "rr"
    ]
  ],
  "./en.json": [
    "Iz",
    [
      "ij"
    ]
  ],
  "./pl.json": [
    "IBF",
    [
      "ms0"
    ]
  ],
  "./ru.json": [
    "VT",
    [
      719
    ]
  ],
  "./tr.json": [
    "waK",
    [
      "az"
    ]
  ],
  "./ja.json": [
    "ir",
    [
      "8h"
    ]
  ],
  "./zh.json": [
    "nvD",
    [
      51
    ]
  ],
  "./pt-br.json": [
    "Kla",
    [
      "ch"
    ]
  ],
  "./de.json": [
    "tmq",
    [
      "3gj"
    ]
  ],
  "./es.json": [
    "OKq",
    [
      "8kp"
    ]
  ],
  "./fr.json": [
    "WVL",
    [
      "8b3"
    ]
  ],
  "./it.json": [
    "a4",
    [
      "ow"
    ]
  ],
  "./ko.json": [
    "P3",
    [
      54
    ]
  ],
  "./pt.json": [
    "UO5",
    [
      "2t"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "ha";
module.exports = __rspack_async_context;
